/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { PubNubMessageAction } from "./PubNubMessageAction";
export const PubNubMessage = core.serialization.object({
    channel: core.serialization.string(),
    message: core.serialization.any(),
    timetoken: core.serialization.string(),
    messageType: core.serialization.string().optional(),
    uuid: core.serialization.string().optional(),
    error: core.serialization.string().optional(),
    meta: core.serialization.record(core.serialization.string(), core.serialization.any()).optional(),
    actions: core.serialization.record(core.serialization.string(), core.serialization.record(core.serialization.string(), core.serialization.list(PubNubMessageAction))),
});
